<template>
  <footer class="section-footer">
    <div class="section-footer__container">
      <router-link :to="'/terms-conditions'">Terms & Conditions</router-link> | <router-link :to="'/wagers'">Wagers</router-link>
    </div>
  </footer>
</template>
<script>
export default {}
</script>
<style scoped lang="scss" src="@/assets/scss/_footer.scss"/>
